module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"title_media":"포토/동영상 첨부하기","title_image":"포토 첨부하기","add_image":"포토 첨부하기","add_video":"동영상 첨부하기","disclaimer":"개인 정보 노출(CCTV/블랙박스), 명예훼손, 저작권 등 권리침해 동영상은 이용약관 및 관련 법률에 의해 제재를 받을 수 있습니다."}}')
  delete Component.options._Ctor
}
